"use client";

import useActionFromParams from "@/hooks/useActionFromParams";
import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

const RecruiterViewContext = createContext({
  isRecruiterView: false,
  setRecruiterView: (status: boolean) => {},
});

export function useRecruiterView() {
  return useContext(RecruiterViewContext);
}

export default function RecruiterViewContextWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const [isRecruiterView, setIsRecruiterView] = useState(false);

  const { cleanup: cleanRecruiterParam } = useActionFromParams(
    useMemo(
      () => [
        {
          // paramKey: "recruiter-view",
          paramKey: "profile-tour",
          expectedValue: "true",
          action: () => setIsRecruiterView(true),
        },
      ],
      [],
    ),
  );

  const setRecruiterView = useCallback((status: boolean) => {
    const current = new URLSearchParams(window.location.search);
    if (status) {
      current.set("profile-tour", status.toString());
      const search = current.toString();
      const query = search ? `?${search}` : "";

      window.history.pushState({}, "", `${window.location.pathname}${query}`);
    } else {
      // current.delete("recruiter-view");
      cleanRecruiterParam();
    }

    setIsRecruiterView(status);
  }, []);

  const value = {
    isRecruiterView,
    setRecruiterView,
  };

  return (
    <RecruiterViewContext.Provider value={value}>
      {children}
    </RecruiterViewContext.Provider>
  );
}
